module.exports = __webpack_public_path__ + "static/04-d669a921e8447cd78b177b5c84bf9ae6.jpg";